<script setup lang="ts">

//vue
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";

//services
import * as clienteService from "@/services/clienteService";
import storeCliente from "@/utils/storeCliente";
import { getToken } from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";
import { di } from "@fullcalendar/core/internal-common";

const router = useRouter();

var controle = reactive({
  model: {} as clienteService.ClienteLogin,
  status: "" as string,
  erro: "" as string
})


function login() {

  // Lógica de login aqui
  controle.status = "Realizando login...";
  console.log("Login:", controle.model);

  clienteService.Login(controle.model)
    .then((r) => {
      storeCliente.usuario = {} as clienteService.ClienteLoginResult;
      storeCliente.token = r.accessToken;
      storeCliente.usuario.clienteId = r.clienteId;
      storeCliente.usuario.nome = r.nome;
      storeCliente.usuario.refreshToken = r.refreshToken;
      storeCliente.usuario.userName = r.userName;

      controle.status = "Entrando...";
      console.log("Entrando com sucesso:", r);

      // Armazenar o token no localStorage ou cookies, se necessário
      localStorage.setItem("clienteToken", r.accessToken);

      // Redirecionar para a área do cliente após o login bem-sucedido
      
      router.push({ name: "PainelCliente" });
    })
    .catch((error) => {
      controle.status = "";
      controle.erro =  error.message || error;
    });
}


</script>
<template>

  <div class="row">

  </div>


  <div class="row">

    <div class="col-md-3">

    </div>

    <div class="col-md-6">

      <div class="row">
        <div class="col-md-12 text-center">
          <h2 class="mt-4 mb-3">Área do Cliente - Login</h2>
        </div>

        <div class="col-md-12 text-center">
          <img :src="imgLogin" alt="Login do Cliente" class="img-fluid">
        </div>
      </div>

      <div class="row">

          <div class="mb-3">
            <label for="cpf" class="form-label">CPF</label>
            <input type="text" class="form-control form-control-sm" id="cpf" placeholder="Digite seu CPF" v-model="controle.model.cpf">
          </div>
          <div class="mb-3">
            <label for="senha" class="form-label">Senha</label>
            <input type="password" class="form-control form-control-sm" id="senha" placeholder="Digite sua senha" v-model="controle.model.senha">
          </div>
          
          <button type="button" class="btn btn-primary btn-sm" @click="login()">Entrar</button>

          <div class="mt-3 text-primary" v-if="controle.erro == ''">
            {{ controle.status }}
          </div>
          <div class="mt-3 text-danger" v-if="controle.erro != ''">
            {{ controle.erro }}
          </div>
      </div>
    </div>

    <div class="col-md-3">

    </div>
  </div>
</template>